import React, { Component } from "react";
import ReactDOM from "react-dom";
import { Navigate  } from 'react-router-dom';



export default class Logout extends Component {
	 constructor(props) {
    super(props);
	 this.state = {redirect:false,pagename:''}
	 }
	componentDidMount() {
		var strusername="",strpawd="";
		if(localStorage.getItem("AYLUsername")!==null)
		{
			strusername=localStorage.getItem("AYLUsername");
			strpawd=localStorage.getItem("AYLpwd");
		}
		localStorage.clear();
		localStorage.setItem("AYLUsername",strusername);
		localStorage.setItem("AYLpwd",strpawd);
		this.setState({
							redirect: true,
							pagename:'/Default'
						  }) 
	}
	render() {
		if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }
return (
<React.Fragment>
</React.Fragment>
)
	}
}



